"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useServiceWorker = void 0;
var _react = require("react");
var _shared = require("../shared");
var _endpoints = require("./endpoints");
var _constants = require("./constants");
/* eslint-disable */

var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
// [::1] is the IPv6 localhost address.
window.location.hostname === '[::1]' ||
// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
function register(config, cb) {
  if ('serviceWorker' in navigator) {
    // The URL constructor is available in all browsers that support SW.
    var publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
      return;
    }
    window.addEventListener('load', function () {
      var swUrl = "".concat(process.env.PUBLIC_URL, "/serviceWorkerTabSync.js");
      if (isLocalhost) {
        // This is running on localhost. Let's check if a service worker still exists or not.
        checkValidServiceWorker(swUrl, config);
      } else {
        // Is not localhost. Just register service worker
        registerValidSW(swUrl, config);
      }
      navigator.serviceWorker.ready.then(function () {
        navigator.serviceWorker.addEventListener('message', function (event) {
          if (!event || event.origin !== location.origin) {
            // No need to handle messages from other windows/origins
            return;
          }
          if (event.data === _constants.ServiceWorkerEvents.LOGOUT) {
            cb.logout();
          }
          if (event.data === _constants.ServiceWorkerEvents.LOGIN && window.location.pathname === (0, _endpoints.getSignInUrl)()) {
            window.location.reload();
          }
        });
      });
    });
  } else {
    console.error('SW: is not available');
  }
}
function registerValidSW(swUrl, config) {
  navigator.serviceWorker.register(swUrl).then(function (registration) {
    registration.onupdatefound = function () {
      var installingWorker = registration.installing;
      if (installingWorker == null) {
        return;
      }
      installingWorker.onstatechange = function () {
        if (installingWorker.state === 'installed') {
          if (navigator.serviceWorker.controller) {
            // Execute callback
            if (config && config.onUpdate) {
              config.onUpdate(registration);
            }
          } else {
            // Execute callback
            if (config && config.onSuccess) {
              config.onSuccess(registration);
            }
          }
        }
      };
    };
  }).catch(function (error) {
    console.error('SW: Error during service worker registration:', error);
  });
}
function checkValidServiceWorker(swUrl, config) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl).then(function (response) {
    // Ensure service worker exists, and that we really are getting a JS file.
    var contentType = response.headers.get('content-type');
    if (response.status === 404 || contentType != null && contentType.indexOf('javascript') === -1) {
      // No service worker found. Probably a different app. Reload the page.
      navigator.serviceWorker.ready.then(function (registration) {
        registration.unregister().then(function () {
          window.location.reload();
        });
      });
    } else {
      // Service worker found. Proceed as normal.
      registerValidSW(swUrl, config);
    }
  }).catch(function () {
    console.error('No internet connection found. App is running in offline mode.');
  });
}

// Unused legacy code but keeping for reference
// function unregister() {
//   if ('serviceWorker' in navigator) {
//     navigator.serviceWorker.ready.then(registration => {
//       registration.unregister();
//     });
//   }
// }

var useServiceWorker = function useServiceWorker() {
  var _useAuth = (0, _shared.useAuth)(),
    logout = _useAuth.logout;
  (0, _react.useEffect)(function () {
    register(null, {
      logout: logout
    });
  }, []);
};
exports.useServiceWorker = useServiceWorker;